import { Switch } from 'antd'
import { observer } from 'mobx-react-lite'

import { classNames } from '@/Ship/Helpers/classNames'

import { USER_ROLE_OPTIONS, assignedRoles, toggleRole } from '../Contracts/UserOptions'

import type { UserFormContextLike } from '../Contracts/IUser'

import { CardField } from './CardField'
import styles from './UserCard.module.css'

/**
 * Ролі у формі створення — ті самі сім перемикачів, що на вкладці «Права
 * доступу», але без запиту: значення йде разом із формою (С3.1). У легасі
 * ролі видавали лише після збереження, окремим кроком.
 *
 * Окремий observer: читає `roles`, які редагують, — шаблон їх не читає
 * (`SPEC-002` §4.2).
 */
export const UserRoleSwitches = observer(({ formContext }: { formContext: UserFormContextLike }) => {
    const roles = assignedRoles(formContext.values?.roles)

    return (
        <CardField label="Права доступу">
            <div className={classNames(styles['roles'])}>
                {USER_ROLE_OPTIONS.map((option) => (
                    <div key={option.value} className={classNames(styles['roleRow'])}>
                        <span>{option.label}</span>
                        <Switch
                            aria-label={option.label}
                            checked={roles.includes(option.value)}
                            onChange={(checked) =>
                                formContext.setValue?.('roles', toggleRole(roles, option.value, checked))
                            }
                        />
                    </div>
                ))}
            </div>
        </CardField>
    )
})
